<template>
  <div class="vui-scroll" ref="scroll" @scroll="onScroll" @wheel="onWheel" @touchstart="onTouchstart" @touchmove="onTouchmove">
    <div v-if="topLoad" class="vui-scroll-loading-wrap" :class="{ 'vui-scroll-loading-wrap-active': topActive }">
      <Spin style="background-color: transparent;"></Spin>
    </div>
    <slot></slot>
    <div v-if="bottomLoad" class="vui-scroll-loading-wrap" :class="{ 'vui-scroll-loading-wrap-active': bottomActive }">
      <Spin style="background-color: transparent;"></Spin>
    </div>
  </div>
</template>

<script>
import Spin from './Spin.vue'

export default {
  name: 'VuiScroll',
  components: {
    Spin,
  },
  props: {
    topLoad: Function,
    bottomLoad: Function,
  },
  data () {
    return {
      DIR: { TOP: 1, BOTTOM: 2 },
      topIsLoading: false,
      bottomIsLoading: false,
      topActive: false,
      bottomActive: false,

      // nowNumer: 5,
      // triggerNumber: 5,
      lastY: 0,
    }
  },
  methods: {
    loadEnd (dir) {
      this.time = Date.now() - this.time

      if (500 - this.time > 20) {
        setTimeout(() => {
          switch (dir) {
            case this.DIR.TOP:
              this.topActive = false
              break
            case this.DIR.BOTTOM:
              this.bottomActive = false
              break
          }
        }, 500 - this.time)
      } else {
        switch (dir) {
          case this.DIR.TOP:
            this.topActive = false
            break
          case this.DIR.BOTTOM:
            this.bottomActive = false
            break
        }
      }

      if (this.time < 1000) {
        this.time = 1500 - this.time
      } else {
        this.time = 500
      }

      setTimeout(() => {
        switch (dir) {
          case this.DIR.TOP:
            this.topIsLoading = false
            break
          case this.DIR.BOTTOM:
            this.bottomIsLoading = false
            break
        }
      }, this.time)
    },
    triggerLoad (dir) {
      let fn

      this.time = Date.now()

      switch (dir) {
        case this.DIR.TOP:
          if (!this.topLoad) {
            return
          }
          this.topIsLoading = true
          this.topActive = true
          fn = this.topLoad.bind(this)
          break
        case this.DIR.BOTTOM:
          if (!this.bottomLoad) {
            return
          }

          this.bottomIsLoading = true
          this.bottomActive = true
          fn = this.bottomLoad.bind(this)
          break
      }

      fn()
        .then(() => {
          this.loadEnd(dir)
        })
        .catch(() => {
          this.loadEnd(dir)
        })
    },
    onScroll () {
      const el = this.$refs.scroll
      let onBottom = false
      let onTop = false

      if (!el) {
        return
      }

      const { scrollTop, scrollHeight } = el
      const elHeight = el.getBoundingClientRect().height

      if (!this.topIsLoading) {
        if (scrollTop === 0) {
          onTop = true
          this.triggerLoad(this.DIR.TOP)
        }
      }

      if (!this.bottomIsLoading) {
        if (scrollTop + elHeight >= scrollHeight) {
          onBottom = true
          this.triggerLoad(this.DIR.BOTTOM)
        }
      }
      let DELAY500 = 500
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.$emit('scrollEnd', { onBottom: onBottom, onTop: onTop })
      }, DELAY500)
    },
    onWheel (e) {
      const el = this.$refs.scroll

      if (!el) {
        return
      }

      const { scrollTop, scrollHeight } = el
      const elHeight = el.getBoundingClientRect().height
      const dir = e.wheelDelta ? e.wheelDelta : -(e.detail || e.deltaY)

      if (!this.topIsLoading && dir > 0) {
        if (scrollTop === 0) {
          this.triggerLoad(this.DIR.TOP)
        }
      }

      if (!this.bottomIsLoading && dir < 0) {
        if (scrollTop + elHeight >= scrollHeight) {
          this.triggerLoad(this.DIR.BOTTOM)
        }
      }
    },
    onTouchstart (e) {
      this.lastY = e.touches[0].clientY
    },
    onTouchmove (e) {
      const el = this.$refs.scroll

      if (!el) {
        return
      }

      const { scrollTop, scrollHeight } = el
      const elHeight = el.getBoundingClientRect().height
      const nowY = e.touches[0].clientY
      const diff = nowY - this.lastY
      this.lastY = nowY

      if (
        !(!this.topIsLoading && diff > 0 && scrollTop === 0)
        && !(!this.bottomIsLoading && diff < 0 && Math.abs(scrollTop + elHeight - scrollHeight) < 4)
      ) {
        return
      }

      e.preventDefault()

      if (!this.topIsLoading && diff > 0) {
        if (scrollTop === 0) {
          this.triggerLoad(this.DIR.TOP)
        }
      }

      if (!this.bottomIsLoading && diff < 0) {
        if (Math.abs(scrollTop + elHeight - scrollHeight) < 4) {
          this.triggerLoad(this.DIR.BOTTOM)
        }
      }
    },
  },
}
</script>

<style lang="scss">
$preCls: '.vui-scroll';

#{$preCls} {
  #{$preCls}-loading-wrap {
    height: 0;
    transform: scale(0);
    transition: transform 0.4s, height 0.4s;

    &-active {
      height: 40px;
      transform: scale(1);
    }
  }
}
</style>
